  export default function Logo() {
  return (
    <svg preserveAspectRatio='none' viewBox='0 0 574 574' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M555.02 222.013C548.816 145.514 545.714 107.265 531.273 82.5185C489.928 11.6614 369.719 -5.19131 293.797 1.27128C192.157 9.92083 75.8816 68.3503 24.699 181.163C-21.7883 283.629 -0.352776 399.613 69.6934 475.485C198.1 614.57 462.972 589.738 527.675 498.473C553.497 462.05 555.358 403.875 558.094 318.417C559.409 277.281 556.843 244.499 555.02 222.013Z'
      fill='#F4F7FA'
    />
    <path
      d='M506.315 46.802C499.744 41.3653 489.775 38.4043 481.349 37.8064C421.619 33.5737 412.902 158.425 422.057 186.327C431.213 214.229 425.281 223.391 378.238 237.989C331.196 252.587 353.764 280.694 359.498 297.131C365.231 313.568 376.586 327.454 342.293 343.786C308 360.119 319.917 370.239 319.917 370.239C319.917 370.239 383.159 434.928 379.666 414.217C376.172 393.507 382.502 362.234 439.203 359.857C463.626 358.833 501.026 347.183 509.306 321.032C511.235 314.942 512.577 305.641 511.111 299.339C509.075 290.595 503.337 283.706 500.151 275.477C492.726 256.3 511.35 242.256 522.068 229.438C527.664 222.746 533.257 215.884 537.54 208.254C546.438 192.413 543.106 175.425 533.418 160.823C528.772 153.822 522.318 146.393 520.29 138.04C518.114 129.069 520.012 116.811 520.528 107.582C520.933 100.344 521.624 93.1336 521.216 85.8765C520.462 72.382 517.301 55.8918 506.315 46.802Z'
      fill='url(#paint0_linear_30_264)'
    />
    <g opacity={0.8}>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M314.944 406.547C314.535 406.694 314.07 406.52 313.863 406.125C313.638 405.693 313.804 405.159 314.236 404.933C314.502 404.794 341.126 390.79 370.826 367.724C398.194 346.471 433.847 312.96 448.281 274.002C460.338 241.466 471.332 187.677 478.448 126.43C484.829 71.5078 485.836 30.8893 483.125 23.3496C482.959 22.891 483.199 22.3852 483.658 22.2193C484.116 22.0534 484.622 22.293 484.788 22.7517C487.96 31.5733 485.947 77.2025 480.205 126.634C473.075 188.017 462.044 241.954 449.94 274.617C435.356 313.974 399.445 347.743 371.887 369.139C342.064 392.295 315.323 406.358 315.057 406.498C315.018 406.516 314.981 406.533 314.944 406.547Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M478.352 137.076C477.895 137.24 477.43 137.113 477.262 136.656C477.041 136.052 454.774 76.1463 426.061 62.6211C425.619 62.4143 425.441 61.9147 425.648 61.4724C425.857 61.03 426.387 60.856 426.827 61.0628C456.198 74.8972 478.002 133.546 478.917 136.042C479.085 136.501 478.815 136.91 478.356 137.074C478.354 137.076 478.352 137.076 478.352 137.076Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M467.492 206.548C467.152 206.671 466.755 206.575 466.511 206.278C466.202 205.901 466.255 205.344 466.632 205.035C466.796 204.9 483.19 191.452 503.417 180.167C530.748 164.92 551.694 160.663 565.672 167.516C566.11 167.732 566.29 168.26 566.075 168.698C565.86 169.136 565.332 169.316 564.894 169.101C532.732 153.334 468.399 205.864 467.754 206.396C467.674 206.464 467.584 206.515 467.492 206.548Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M396.119 348.552C396.029 348.585 395.934 348.601 395.834 348.603C395.347 348.611 394.945 348.222 394.937 347.733C394.933 347.477 394.478 321.774 389.099 294.691C384.166 269.86 373.981 238.757 353.471 231.59C353.01 231.429 352.766 230.925 352.928 230.466C353.088 230.005 353.594 229.762 354.052 229.924C371.155 235.899 383.529 257.582 390.836 294.371C396.244 321.608 396.698 347.448 396.702 347.706C396.71 348.095 396.465 348.427 396.119 348.552Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M432.615 307.026C432.257 307.155 431.843 307.04 431.606 306.719C431.315 306.325 431.399 305.772 431.79 305.484C434.634 303.381 501.726 254.057 527.889 258.767C528.371 258.853 528.688 259.314 528.602 259.793C528.516 260.274 528.057 260.594 527.576 260.506C502.154 255.929 433.531 306.393 432.841 306.903C432.771 306.958 432.693 306.997 432.615 307.026Z'
          fill='white'
        />
      </g>
    </g>
    <path
      d='M558.737 230.694C554.394 223.355 546.015 217.195 538.289 213.782C483.513 189.588 433.065 304.125 432.238 333.479C431.41 362.833 422.728 369.447 373.524 367.266C324.317 365.086 336.042 399.172 335.876 416.579C335.71 433.987 341.696 450.895 303.899 454.661C266.102 458.427 273.892 471.98 273.892 471.98C273.892 471.98 311.515 554.253 315.235 533.582C318.956 512.91 335.493 485.624 389.653 502.575C412.981 509.875 452.117 511.569 468.759 489.763C472.635 484.684 477.044 476.387 477.795 469.959C478.838 461.044 475.77 452.619 475.555 443.798C475.055 423.239 497.335 416.325 511.757 407.891C519.286 403.488 526.871 398.922 533.485 393.192C547.217 381.297 549.832 364.184 545.657 347.166C543.654 339.006 540.093 329.83 541.012 321.285C541.999 312.107 547.934 301.213 551.542 292.703C554.372 286.029 557.462 279.477 559.534 272.51C563.394 259.55 566.001 242.964 558.737 230.694Z'
      fill='url(#paint1_linear_30_264)'
    />
    <g opacity={0.8}>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M256.926 504.461C256.492 504.461 256.113 504.139 256.052 503.697C255.986 503.214 256.324 502.767 256.807 502.702C257.104 502.661 286.897 498.492 322.65 486.836C355.593 476.098 400.483 456.626 427.249 424.852C449.604 398.313 478.151 351.419 505.57 296.192C530.157 246.67 544.849 208.787 544.849 200.774C544.849 200.287 545.245 199.892 545.732 199.892C546.219 199.892 546.615 200.287 546.615 200.774C546.615 210.149 529.281 252.405 507.151 296.978C479.671 352.326 451.039 399.35 428.599 425.99C401.558 458.09 356.339 477.716 323.166 488.525C287.267 500.224 257.344 504.41 257.045 504.451C257.008 504.459 256.967 504.461 256.926 504.461Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M501.879 306.361C501.394 306.361 500.998 305.992 500.996 305.507C500.992 304.864 500.31 240.912 477.867 218.469C477.521 218.125 477.521 217.57 477.867 217.226C478.211 216.882 478.77 216.884 479.116 217.228C502.073 240.185 502.745 302.837 502.763 305.495C502.768 305.982 502.374 306.361 501.885 306.361C501.881 306.361 501.879 306.361 501.879 306.361Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M468.152 367.88C467.79 367.88 467.45 367.655 467.321 367.295C467.157 366.836 467.395 366.33 467.855 366.164C468.054 366.093 488.032 358.985 510.886 355.211C541.764 350.11 562.915 353.194 573.751 364.372C574.091 364.723 574.081 365.282 573.731 365.622C573.38 365.962 572.821 365.951 572.481 365.601C547.553 339.882 469.24 367.544 468.451 367.827C468.351 367.864 468.251 367.88 468.152 367.88Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M352.938 477.356C352.844 477.356 352.748 477.339 352.651 477.309C352.191 477.151 351.943 476.649 352.103 476.186C352.185 475.943 360.455 451.604 364.557 424.297C368.316 399.262 369.256 366.548 352.381 352.863C352.002 352.556 351.945 351.999 352.252 351.62C352.559 351.241 353.116 351.182 353.495 351.491C367.567 362.901 371.875 387.494 366.299 424.582C362.173 452.042 353.858 476.512 353.774 476.758C353.649 477.124 353.305 477.356 352.938 477.356Z'
          fill='white'
        />
      </g>
      <g opacity={0.8}>
        <path
          opacity={0.8}
          d='M401.331 450.629C400.95 450.629 400.6 450.381 400.485 450C400.344 449.533 400.61 449.04 401.077 448.901C404.464 447.885 484.288 424.172 507.315 437.458C507.737 437.702 507.882 438.242 507.638 438.664C507.395 439.086 506.854 439.231 506.432 438.988C484.057 426.079 402.406 450.346 401.585 450.592C401.501 450.617 401.415 450.629 401.331 450.629Z'
          fill='white'
        />
      </g>
    </g>
    <path
      d='M375.122 24.3593L374.491 28.8766C372.396 28.9728 370.336 29.2431 368.332 29.6936L366.624 25.4794C366.159 24.3306 364.842 23.7839 363.685 24.261L356.443 27.2445C355.283 27.7216 354.718 29.0445 355.181 30.1953L356.897 34.4627C355.142 35.5808 353.484 36.8463 351.94 38.2469L348.303 35.4251C347.32 34.6634 345.895 34.8518 345.119 35.847L340.253 42.072C339.473 43.0693 339.639 44.4986 340.622 45.2624L344.273 48.1005C343.3 49.9271 342.483 51.856 341.824 53.8689L337.19 53.2607C335.945 53.0969 334.786 53.9795 334.602 55.2327L333.436 63.0836C333.25 64.3409 334.11 65.4959 335.357 65.6597L340.005 66.2699C340.061 68.3893 340.292 70.4738 340.704 72.5031L336.342 74.3215C335.167 74.8109 334.589 76.1645 335.052 77.3419L337.958 84.726C338.423 85.9095 339.756 86.4686 340.935 85.9751L345.299 84.1485C346.396 85.9341 347.648 87.6173 349.036 89.1818L346.128 92.9578C345.342 93.9796 345.51 95.4416 346.505 96.2239L352.738 101.114C353.735 101.896 355.183 101.699 355.967 100.674L358.84 96.9221C360.675 97.8989 362.616 98.7118 364.642 99.361L363.988 104.042C363.81 105.324 364.685 106.497 365.942 106.661L373.811 107.693C375.071 107.859 376.232 106.952 376.408 105.67L377.043 101.024C379.182 100.932 381.285 100.655 383.331 100.194L385.057 104.486C385.536 105.678 386.878 106.241 388.053 105.744L395.392 102.633C396.565 102.136 397.124 100.77 396.643 99.5821L394.917 95.3208C396.709 94.1639 398.396 92.8513 399.961 91.3994L403.548 94.1884C404.552 94.9686 405.989 94.772 406.759 93.7502L411.565 87.3777C412.333 86.36 412.142 84.9082 411.141 84.1321L407.586 81.3759C408.555 79.4981 409.36 77.5139 409.998 75.4478L414.442 76.0313C415.689 76.1952 416.832 75.3044 416.994 74.043L418.003 66.1716C418.165 64.9164 417.286 63.7655 416.041 63.6017L411.61 63.0202C411.518 60.8742 411.248 58.7691 410.793 56.7234L414.903 55.0034C416.058 54.5201 416.604 53.185 416.125 52.0219L413.123 44.7648C412.644 43.6058 411.321 43.057 410.166 43.5382L406.032 45.2624C404.906 43.4952 403.632 41.8283 402.217 40.2864L404.949 36.7214C405.709 35.7282 405.522 34.3091 404.535 33.5494L398.361 28.8049C397.374 28.0472 395.959 28.2336 395.198 29.2226L392.45 32.7918C390.627 31.8457 388.702 31.0594 386.693 30.4369L387.306 25.9545C387.474 24.7217 386.612 23.5893 385.377 23.4276L377.663 22.416C376.434 22.2583 375.294 23.1245 375.122 24.3593ZM347.926 60.9499C350.156 45.4364 364.394 34.561 379.741 36.5739C395.089 38.5868 405.868 52.7447 403.806 68.2787C401.732 83.9089 387.463 94.9973 371.948 92.9639C356.432 90.9285 345.684 76.5576 347.926 60.9499Z'
      fill='#D8DEE8'
    />
    <path
      d='M256.842 21.9099L255.867 28.8946C252.63 29.0421 249.443 29.4598 246.343 30.156L243.704 23.6402C242.983 21.8628 240.949 21.0191 239.162 21.7563L227.963 26.3698C226.171 27.109 225.297 29.1506 226.013 30.9342L228.667 37.5319C225.954 39.2602 223.388 41.2158 221.003 43.3843L215.371 39.0206C213.854 37.8432 211.649 38.136 210.449 39.6718L202.925 49.296C201.719 50.838 201.975 53.0475 203.495 54.229L209.14 58.6193C207.637 61.4431 206.372 64.4266 205.352 67.5371L198.187 66.5972C196.264 66.3453 194.472 67.7091 194.184 69.6462L192.384 81.7871C192.095 83.7325 193.426 85.516 195.355 85.7679L202.54 86.7099C202.626 89.9862 202.983 93.2114 203.622 96.3485L196.879 99.16C195.06 99.9176 194.167 102.008 194.884 103.831L199.377 115.247C200.095 117.075 202.158 117.942 203.98 117.178L210.727 114.354C212.423 117.114 214.358 119.717 216.506 122.135L212.011 127.973C210.795 129.554 211.055 131.815 212.595 133.023L222.233 140.583C223.775 141.793 226.013 141.488 227.228 139.903L231.669 134.104C234.505 135.615 237.509 136.873 240.64 137.876L239.629 145.115C239.352 147.097 240.704 148.911 242.651 149.165L254.819 150.76C256.764 151.016 258.562 149.614 258.832 147.631L259.815 140.448C263.124 140.307 266.376 139.879 269.538 139.166L272.206 145.803C272.947 147.646 275.021 148.516 276.838 147.746L288.186 142.938C289.998 142.17 290.865 140.057 290.119 138.218L287.449 131.629C290.22 129.841 292.828 127.81 295.249 125.565L300.794 129.878C302.344 131.084 304.566 130.779 305.758 129.202L313.189 119.35C314.374 117.778 314.082 115.531 312.533 114.331L307.037 110.072C308.536 107.167 309.779 104.099 310.766 100.907L317.638 101.808C319.567 102.062 321.335 100.683 321.584 98.734L323.145 86.5624C323.395 84.6191 322.035 82.8417 320.112 82.5899L313.26 81.6909C313.119 78.3736 312.701 75.1177 311.997 71.9561L318.353 69.2961C320.141 68.5487 320.986 66.4846 320.241 64.6867L315.599 53.4652C314.858 51.6734 312.812 50.8257 311.028 51.569L304.638 54.2331C302.897 51.4994 300.925 48.9234 298.74 46.5419L302.962 41.0294C304.138 39.4957 303.851 37.3005 302.322 36.1251L292.775 28.7902C291.25 27.6189 289.061 27.9077 287.883 29.4373L283.632 34.9559C280.812 33.4938 277.837 32.2775 274.733 31.313L275.681 24.3815C275.941 22.4751 274.606 20.7263 272.699 20.4765L260.771 18.912C258.869 18.6622 257.108 20.0035 256.842 21.9099ZM214.792 78.4862C218.238 54.4993 240.253 37.6834 263.982 40.796C287.711 43.9085 304.377 65.7986 301.191 89.8183C297.984 113.983 275.924 131.131 251.935 127.984C227.944 124.838 211.323 102.617 214.792 78.4862Z'
      fill='#D8DEE8'
    />
    <path
      d='M245.429 89.5458L193.262 523.158C192.48 529.659 196.96 535.487 203.238 536.11L420.526 559.965C433.836 560.793 441.124 553.992 441.947 547.079L496.717 86.077C497.534 79.2028 491.004 72.9757 477.636 72.9757L258.373 77.5933C252.023 77.7018 246.208 83.0791 245.429 89.5458Z'
      fill='url(#paint2_linear_30_264)'
    />
    <path
      d='M235.65 88.801L183.195 524.582C182.409 531.116 186.906 536.974 193.205 537.601L418.47 560.03C425.532 560.732 432.005 555.623 432.83 548.675L487.908 85.2912C488.729 78.3801 483.542 72.8267 476.402 72.9476L248.638 76.7911C242.27 76.8956 236.432 82.3015 235.65 88.801Z'
      fill='url(#paint3_linear_30_264)'
    />
    <path
      d='M239.925 112.837L191.306 516.892C190.571 522.996 194.783 528.459 200.679 529.033L412.533 549.627C419.098 550.266 425.114 545.496 425.884 539.028L476.784 110.969C477.55 104.535 472.734 99.3278 466.101 99.3995L252.072 101.679C246.115 101.74 240.656 106.763 239.925 112.837Z'
      fill='#D8DEE8'
    />
    <path
      d='M353.533 88.4995C353.254 90.8196 354.919 92.6769 357.253 92.6462C359.59 92.6175 361.711 90.709 361.99 88.3849C362.268 86.0607 360.597 84.2034 358.261 84.2382C355.924 84.2731 353.809 86.1815 353.533 88.4995Z'
      fill='url(#paint4_linear_30_264)'
    />
    <path
      d='M276.552 384.065C319.923 303.878 384.715 279.875 404.221 197.233C414.765 152.562 407.581 109.806 395.481 74.3111L476.405 72.9452C483.546 72.8244 488.732 78.3799 487.911 85.2889L432.834 548.673C432.009 555.623 425.536 560.732 418.473 560.027L241.393 542.396C240.08 470.546 257.218 419.808 276.552 384.065Z'
      fill='white'
    />
    <path
      d='M21.7816 134.787C21.7816 92.1778 58.9497 57.6431 103.553 57.6472C146.838 57.6513 180.998 90.3697 180.998 130.724C180.998 171.078 146.838 205.539 103.553 207.753C58.9476 210.034 21.7816 177.396 21.7816 134.787Z'
      fill='url(#paint5_linear_30_264)'
    />
    <path
      d='M26.5896 131.389C26.5896 88.7803 62.6827 54.2456 105.994 54.2497C148.025 54.2538 181.198 86.9722 181.198 127.327C181.198 167.681 148.025 202.142 105.994 204.355C62.6806 206.637 26.5896 173.996 26.5896 131.389Z'
      fill='url(#paint6_linear_30_264)'
    />
    <g opacity={0.5}>
      <path
        opacity={0.5}
        d='M38.9457 131.063C38.9457 95.2653 69.2683 66.2492 105.658 66.2553C140.971 66.2594 168.843 93.7479 168.843 127.652C168.843 161.556 140.973 190.509 105.658 192.368C69.2683 194.285 38.9457 166.862 38.9457 131.063Z'
        fill='white'
      />
    </g>
    <path
      opacity={0.5}
      d='M103.154 71.7555C138.467 71.7596 166.338 99.2481 166.338 133.152C166.338 141.214 164.747 148.989 161.87 156.193C166.326 147.519 168.845 137.811 168.845 127.652C168.845 93.7479 140.975 66.2594 105.66 66.2553C77.5944 66.2533 53.1529 83.5196 43.4324 107.838C54.4389 86.4581 77.2545 71.7534 103.154 71.7555Z'
      fill='white'
    />
    <path
      d='M75.4862 122.302V153.546C75.4862 162.578 83.0853 169.704 92.4311 169.461L115.605 168.856C124.838 168.615 132.3 161.176 132.3 152.237V121.323L75.4862 122.302ZM96.8275 154.602L101.134 141.552C99.2889 140.6 98.0398 138.724 98.0398 136.539C98.0398 133.333 100.73 130.681 104.044 130.62C107.353 130.556 110.033 133.099 110.033 136.3C110.033 138.481 108.788 140.404 106.949 141.431L111.239 154.267L96.8275 154.602Z'
      fill='white'
    />
    <path
      d='M125.712 118.614C123.253 118.655 121.259 116.752 121.259 114.363C121.259 105.179 113.549 97.8068 104.042 97.9297C94.5012 98.0525 86.7137 105.672 86.7137 114.913C86.7137 117.317 84.6926 119.3 82.1965 119.343C79.6983 119.384 77.671 117.467 77.671 115.059C77.671 100.993 89.5334 89.4153 104.044 89.2535C118.476 89.0917 130.158 100.293 130.158 114.223C130.158 116.607 128.17 118.573 125.712 118.614Z'
      fill='white'
    />
    <path
      d='M179.387 296.82C179.387 296.82 177.81 290.91 178.928 289.399C180.044 287.888 186.873 281.847 186.218 283.817C185.561 285.787 184.576 287.099 184.576 287.099C184.576 287.099 188.253 288.807 185.888 291.367C183.525 293.929 182.735 294.518 182.604 296.818C182.475 299.117 180.964 299.906 179.387 296.82Z'
      fill='url(#paint7_linear_30_264)'
    />
    <path
      d='M113.788 551.918C113.788 551.918 112.953 557.029 113.059 558.848C113.166 560.666 133.352 561.596 133.555 560.234C133.758 558.872 130.219 556.704 127.727 555.94C125.235 555.174 117.941 553.134 117.941 553.134L113.788 551.918Z'
      fill='url(#paint8_linear_30_264)'
    />
    <path
      d='M118.688 546.824L118.045 553.18C118.045 553.18 115.7 554.73 113.634 553.534L112.6 546.617L118.688 546.824Z'
      fill='url(#paint9_linear_30_264)'
    />
    <path
      d='M77.7714 560.203C77.7714 560.203 76.9359 565.314 77.0424 567.133C77.1489 568.951 97.3353 569.881 97.538 568.519C97.7428 567.157 94.2023 564.989 91.7102 564.225C89.2181 563.461 81.9242 561.42 81.9242 561.42L77.7714 560.203Z'
      fill='url(#paint10_linear_30_264)'
    />
    <path
      d='M82.6723 555.108L82.0294 561.464C82.0294 561.464 79.6847 563.015 77.6186 561.819L76.5845 554.902L82.6723 555.108Z'
      fill='url(#paint11_linear_30_264)'
    />
    <path
      d='M115.026 380.905C117.358 385.635 119.692 390.366 122.025 395.096C123.9 422.091 124.834 451.447 124.234 482.84C123.788 506.197 122.541 528.322 120.747 549.09C117.583 548.945 114.419 548.799 111.256 548.654C106.681 539.574 101.281 525.82 100.784 508.84C100.266 491.13 105.635 488.777 105.295 471.82C104.853 449.839 95.6358 443.975 90.7254 417.537C88.8476 407.425 87.5842 394.219 89.0852 378.198C97.7327 379.101 106.378 380.004 115.026 380.905Z'
      fill='url(#paint12_linear_30_264)'
    />
    <path
      opacity={0.3}
      d='M89.0869 378.198C93.7557 378.685 98.4245 379.173 103.095 379.66C111.501 394.287 113.848 409.51 112.372 416.245C110.285 425.773 104.764 428.824 105.069 438.389C105.37 447.853 110.946 450.308 114.483 461.462C116.932 469.186 116.285 476.288 114.892 490.175C112.087 518.149 105.331 526.705 110.989 535.876C112.597 538.483 115.494 541.585 121.171 543.955C121.031 545.67 120.894 547.391 120.749 549.088C117.585 548.945 114.421 548.797 111.258 548.654C106.683 539.574 101.283 525.82 100.786 508.84C100.267 491.13 105.637 488.777 105.297 471.82C104.854 449.839 95.6376 443.977 90.7272 417.539C88.8494 407.427 87.5839 394.221 89.0869 378.198Z'
      fill='url(#paint13_linear_30_264)'
    />
    <path
      d='M102.471 389.422C98.0905 413.306 94.2223 438.868 91.204 465.977C87.5591 498.71 85.6137 529.569 84.8499 558.219C81.377 558.317 77.9061 558.415 74.4332 558.514C60.7504 531.445 59.9149 513.093 61.8868 501.145C62.6466 496.542 64.7127 487.513 65.1837 474.019C65.5113 464.614 64.9113 457.455 64.1619 448.85C62.5196 429.985 60.5251 425.867 60.2384 411.437C59.9681 397.893 59.9128 391.041 63.7789 387.042C73.9643 376.503 100.462 388.488 102.471 389.422Z'
      fill='url(#paint14_linear_30_264)'
    />
    <path
      d='M177.571 295.909C179.881 295.747 182.189 295.587 184.499 295.426C189.946 317.441 186.039 338.794 173.744 346.647C154.535 358.917 118.833 335.8 111.096 310.628C107.701 299.578 108.473 283.635 115.261 280.537C117.145 279.677 120.069 279.544 126.403 283.098C145.318 293.718 145.815 313.789 155.431 315.489C159.703 316.247 166.608 313.521 177.571 295.909Z'
      fill='url(#paint15_linear_30_264)'
    />
    <path
      d='M124.683 399.939C128.01 394.418 123.831 389.094 122.881 378.636C121.804 366.782 126.37 364.808 130.885 345.164C133.889 332.1 136.77 319.558 133.33 304.876C131.682 297.84 128.885 285.905 119.006 280.141C113.91 277.166 106.949 277.465 93.2399 278.182C76.2849 279.068 67.8094 279.51 61.486 282.84C60.5605 283.327 41.3283 293.789 40.0034 310.843C38.656 328.199 57.5565 330.531 60.0772 353.677C61.2096 364.067 59.1926 380.047 57.8841 390.411C56.6288 400.363 55.7627 402.91 57.7285 405.924C62.4628 413.187 76.9545 411.117 105.938 406.979C117.307 405.353 122.199 404.059 124.683 399.939Z'
      fill='url(#paint16_linear_30_264)'
    />
    <path
      d='M80.5821 349.952C79.3555 354.463 74.9488 357.832 71.8813 368.805C71.2199 371.175 66.4999 388.046 72.6205 392.198C76.1549 394.596 79.3289 390.052 87.9088 389.459C102.775 388.431 109.858 400.926 119.571 397.512C121.256 396.918 123.48 395.657 125.701 392.757C126.144 395.37 126.068 397.641 124.684 399.941C122.202 404.061 117.308 405.355 105.939 406.979C76.9556 411.117 62.4639 413.188 57.7295 405.924C55.7658 402.912 56.6299 400.363 57.8852 390.411C59.1937 380.045 61.2107 364.065 60.0783 353.677C57.5575 330.531 38.6551 328.199 40.0045 310.843C40.3649 306.203 42.0707 302.072 44.3539 298.474C68.3306 308.177 84.4338 335.776 80.5821 349.952Z'
      fill='url(#paint17_linear_30_264)'
    />
    <path
      d='M50.2996 384.091L55.0974 387.155C55.9595 386.159 57.954 384.153 61.0665 383.469C64.5742 382.697 68.6021 383.805 68.6942 384.923C68.77 385.82 66.3168 386.725 65.938 386.864C62.8767 387.994 60.6058 387.054 59.3689 388.285C58.9307 388.719 58.386 389.53 57.1308 390.279C56.8011 390.476 56.4571 390.65 56.2748 390.722C54.2312 391.516 50.7276 387.959 50.4266 387.648L50.2996 384.091Z'
      fill='url(#paint18_linear_30_264)'
    />
    <path
      d='M64.4715 321.173C67.9424 312.861 70.3464 300.135 64.8647 281.237C28.7471 295.468 10.3279 329.206 17.5195 355.949C23.4476 377.997 45.0182 388.735 49.8304 390.996C50.9505 388.447 52.0706 385.899 53.1886 383.352C47.6127 377.143 41.3283 367.961 42.217 357.483C43.4497 342.957 57.4458 337.999 64.4715 321.173Z'
      fill='url(#paint19_linear_30_264)'
    />
    <path
      d='M92.3505 261.083C92.3505 261.083 92.0659 267.4 90.1042 272.132C88.3309 276.408 79.0097 279.097 77.1196 280.051C75.2296 281.005 80.6601 283.796 86.1132 284.343C91.5663 284.892 107.137 283.653 109.944 281.587C112.752 279.52 107.688 279.676 103.797 278.247C99.9045 276.817 97.6541 269.206 98.3421 265.752C99.0302 262.295 92.3505 261.083 92.3505 261.083Z'
      fill='url(#paint20_linear_30_264)'
    />
    <path
      d='M100.975 258.792C103.805 256.011 104.201 255.687 104.508 254.727C105.745 250.871 102.753 245.588 98.8295 244.288C98.6247 244.22 95.9934 243.378 94.99 244.519C94.1361 245.488 95.3914 246.827 94.7955 248.696C94.2365 250.445 92.7211 250.576 89.9096 252.87C87.5937 254.758 86.1562 255.933 85.8244 257.586C85.1405 260.991 89.2626 265.926 92.9116 265.793C94.2242 265.744 94.5825 265.074 100.975 258.792Z'
      fill='url(#paint21_linear_30_264)'
    />
    <path
      d='M93.2705 266.319C93.2705 266.319 96.2786 269.724 100.859 268.598C104.961 267.591 103.915 258.175 100.913 256.672C99.9112 256.171 98.0908 256.211 96.723 256.871C95.9141 257.26 95.6889 257.665 94.3558 258.276C93.1272 258.839 92.7361 258.761 92.4064 259.158C91.9927 259.654 91.8146 260.723 93.1108 263.299C92.177 262.637 91.1716 262.498 90.5552 262.936C90.4569 263.006 90.2071 263.252 90.0986 263.573C89.7075 264.738 90.9197 265.924 93.2705 266.319Z'
      fill='url(#paint22_linear_30_264)'
    />
    <path
      d='M436.316 138.838L437.375 144.554L415.581 144.605L226.454 145.053C221.588 145.065 217.114 149.087 216.446 154.037L171.298 455.774C170.627 460.768 178.4 468.392 183.237 468.764L267.142 475.213V475.11L392.65 484.739C392.652 484.739 392.654 484.739 392.657 484.739L392.96 484.865C398.318 485.279 403.235 481.391 403.931 476.116C403.931 476.114 403.931 476.138 403.933 476.136L446.215 153.979C446.903 148.753 441.705 138.824 436.316 138.838Z'
      fill='url(#paint23_linear_30_264)'
    />
    <path
      d='M399.655 469.838C398.963 475.115 394.049 479.059 388.69 478.647L178.75 462.528C173.915 462.157 170.551 457.808 171.222 452.813L212.265 147.867C212.93 142.918 217.405 138.896 222.266 138.882L433.392 138.3C438.779 138.286 442.6 142.511 441.916 147.736L399.655 469.838Z'
      fill='url(#paint24_linear_30_264)'
    />
    <path
      d='M402.445 302.135C402.101 304.748 399.66 306.697 396.994 306.599L212.222 299.856C209.783 299.768 208.067 297.759 208.403 295.263L212.036 268.337C212.372 265.843 214.597 264.156 217.038 264.223L401.972 269.359C404.642 269.433 406.532 271.319 406.19 273.93L402.445 302.135Z'
      fill='white'
    />
    <path
      d='M395.29 356.844C394.946 359.463 392.503 361.697 389.837 361.564L205.204 352.443C202.768 352.323 201.072 349.99 201.408 347.492L205.069 320.047C205.405 317.55 207.652 315.411 210.09 315.509L394.835 322.961C397.501 323.069 399.387 325.481 399.043 328.096L395.29 356.844Z'
      fill='white'
    />
    <path
      opacity={0.1}
      d='M406.205 273.821C405.766 273.68 405.296 273.602 404.794 273.588L219.856 268.454C217.418 268.385 215.19 270.076 214.858 272.564L211.219 299.489C211.211 299.559 211.205 299.625 211.199 299.694C209.323 299.166 208.117 297.388 208.399 295.259L212.038 268.333C212.37 265.845 214.598 264.152 217.037 264.224L401.974 269.357C404.597 269.435 406.479 271.262 406.205 273.821Z'
      fill='url(#paint25_linear_30_264)'
    />
    <path
      opacity={0.1}
      d='M399.083 327.49C398.639 327.314 398.159 327.207 397.652 327.187L212.911 319.733C210.472 319.635 208.221 321.779 207.89 324.275L204.222 351.722C204.202 351.899 204.188 352.069 204.188 352.245C202.312 351.638 201.12 349.621 201.403 347.492L205.07 320.044C205.402 317.548 207.65 315.404 210.091 315.502L394.832 322.956C397.299 323.063 399.089 325.121 399.083 327.49Z'
      fill='url(#paint26_linear_30_264)'
    />
    <path
      d='M346.186 401.188C346.731 397.057 343.811 393.253 339.66 393.013L244.083 387.525C240.125 387.298 236.469 390.632 235.931 394.653L231.987 424.382C231.448 428.41 234.194 432.264 238.151 432.534L333.679 439.07C337.827 439.355 341.648 435.851 342.195 431.715L346.186 401.188Z'
      fill='url(#paint27_linear_30_264)'
    />
    <path
      d='M353.404 200.894C352.145 210.397 347.263 218.975 340.321 225.284C332.841 232.089 322.988 236.229 312.741 236.031C302.545 235.834 293.963 231.38 288.453 224.424C283.37 218.013 280.88 209.47 282.127 200.126C284.722 180.687 302.582 164.973 322.181 165.02C341.966 165.063 356.021 181.123 353.404 200.894Z'
      fill='url(#paint28_linear_30_264)'
    />
    <path
      d='M334.346 190.092C333.216 198.607 325.357 205.43 316.824 205.327C308.326 205.225 302.375 198.289 303.5 189.836C304.626 181.386 312.405 174.569 320.907 174.608C329.446 174.647 335.477 181.578 334.346 190.092Z'
      fill='white'
    />
    <path
      d='M340.323 225.285C332.843 232.089 322.989 236.23 312.743 236.031C302.547 235.835 293.965 231.381 288.455 224.425C294.762 215.638 305.164 209.794 316.211 209.937C327.318 210.08 336.271 216.236 340.323 225.285Z'
      fill='white'
    />
    <path
      opacity={0.4}
      d='M441.914 147.735L399.655 469.837C398.963 475.112 393.736 479.033 388.379 478.622L262.286 468.94C256.297 462.807 251.364 455.448 247.844 446.616C246.116 442.285 244.85 437.612 244.009 432.697C241.668 419.096 242.575 403.636 245.989 388.461C248.614 376.778 252.73 365.246 257.999 354.839C262.213 346.519 267.168 338.912 272.703 332.519C276.688 327.918 280.999 323.448 285.544 319.064C291.026 313.772 296.852 308.608 302.862 303.491C316.866 291.559 331.862 279.893 345.745 267.574C377.78 239.156 403.769 207.402 397.516 162.094C397.315 160.667 395.363 149.738 392.869 138.41L433.078 138.299C438.464 138.285 442.6 142.512 441.914 147.735Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_30_264'
        x1={383.948}
        y1={413.56}
        x2={533.511}
        y2={9.62239}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.00359712} stopColor='#E38DDD' />
        <stop offset={1} stopColor='#9571F6' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_30_264'
        x1={273.229}
        y1={373.682}
        x2={563.334}
        y2={373.682}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF9085' />
        <stop offset={1} stopColor='#FB6FBB' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_30_264'
        x1={347.677}
        y1={305.291}
        x2={433.309}
        y2={314.632}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#444B8C' />
        <stop offset={0.9964} stopColor='#26264F' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_30_264'
        x1={272.228}
        y1={89.4403}
        x2={483.97}
        y2={810.298}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#444B8C' />
        <stop offset={0.9964} stopColor='#26264F' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_30_264'
        x1={351.573}
        y1={71.6846}
        x2={600.426}
        y2={745.664}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_30_264'
        x1={-1822.59}
        y1={1946.95}
        x2={-1652.37}
        y2={1786.44}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311944' />
        <stop offset={1} stopColor='#893976' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_30_264'
        x1={52.1602}
        y1={176.252}
        x2={188.561}
        y2={52.4724}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF9085' />
        <stop offset={1} stopColor='#FB6FBB' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_30_264'
        x1={190.358}
        y1={283.883}
        x2={163.328}
        y2={311.395}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_30_264'
        x1={123.359}
        y1={545.22}
        x2={123.587}
        y2={484.184}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_30_264'
        x1={117.313}
        y1={564.833}
        x2={114.407}
        y2={533.294}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_30_264'
        x1={87.3749}
        y1={545.085}
        x2={87.6026}
        y2={484.049}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_30_264'
        x1={80.8438}
        y1={568.193}
        x2={77.9375}
        y2={536.654}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_30_264'
        x1={116.21}
        y1={405.916}
        x2={93.8377}
        y2={520.293}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311944' />
        <stop offset={1} stopColor='#893976' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_30_264'
        x1={127.374}
        y1={461.845}
        x2={93.7628}
        y2={464.539}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311944' />
        <stop offset={1} stopColor='#893976' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_30_264'
        x1={108.783}
        y1={468.167}
        x2={57.7579}
        y2={472.257}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311944' />
        <stop offset={1} stopColor='#893976' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_30_264'
        x1={149.087}
        y1={299.754}
        x2={111.336}
        y2={542.198}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_30_264'
        x1={68.7975}
        y1={565.872}
        x2={50.5388}
        y2={810.557}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_30_264'
        x1={6.72031}
        y1={482.443}
        x2={107.493}
        y2={309.828}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_30_264'
        x1={42.4438}
        y1={363.093}
        x2={63.6974}
        y2={391.804}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_30_264'
        x1={24.1875}
        y1={562.543}
        x2={5.92882}
        y2={807.228}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AA80F9' />
        <stop offset={0.9964} stopColor='#6165D7' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_30_264'
        x1={102.799}
        y1={291.55}
        x2={82.3384}
        y2={266.092}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint21_linear_30_264'
        x1={87.241}
        y1={282.2}
        x2={98.0855}
        y2={246.525}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#444B8C' />
        <stop offset={0.9964} stopColor='#3E4177' />
      </linearGradient>
      <linearGradient
        id='paint22_linear_30_264'
        x1={114.898}
        y1={269.751}
        x2={84.3948}
        y2={256.173}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFC444' />
        <stop offset={0.9964} stopColor='#F36F56' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_30_264'
        x1={171.258}
        y1={311.868}
        x2={446.277}
        y2={311.868}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311944' />
        <stop offset={1} stopColor='#893976' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_30_264'
        x1={338.461}
        y1={852.78}
        x2={305.668}
        y2={284.762}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.003597} stopColor='#F36F56' />
        <stop offset={1} stopColor='#FFC444' />
      </linearGradient>
      <linearGradient
        id='paint25_linear_30_264'
        x1={208.358}
        y1={281.96}
        x2={406.23}
        y2={281.96}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.003597} stopColor='#F36F56' />
        <stop offset={1} stopColor='#FFC444' />
      </linearGradient>
      <linearGradient
        id='paint26_linear_30_264'
        x1={201.363}
        y1={333.873}
        x2={399.083}
        y2={333.873}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.003597} stopColor='#F36F56' />
        <stop offset={1} stopColor='#FFC444' />
      </linearGradient>
      <linearGradient
        id='paint27_linear_30_264'
        x1={298.547}
        y1={353.04}
        x2={254.348}
        y2={633.329}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.003597} stopColor='#F36F56' />
        <stop offset={1} stopColor='#FFC444' />
      </linearGradient>
      <linearGradient
        id='paint28_linear_30_264'
        x1={313.086}
        y1={61.2095}
        x2={322.525}
        y2={342.296}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.003597} stopColor='#F36F56' />
        <stop offset={1} stopColor='#FFC444' />
      </linearGradient>
    </defs>
  </svg>
  );
}
